import { Button, Modal, useDisclosure } from "@heroui/react";
import RedButton from "/app/src/components/HeroUi/RedButton";
import ModalBuilder from "/app/src/components/HeroUi/helpers/ModalBuilder";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";

/**
 * DeleteButton component renders a button for deleting an item.
 *
 * @param {Object} param0 - The props object.
 * @param {function} param0.onClick - The click event handler.
 * @param {boolean} param0.disabled - Flag indicating if the button is disabled.
 * @param {string} param0.modalHeader - Text for the modal header.
 */
const DeleteButton = ({
  onClick,
  disabled,
  modalHeader,
  modalBody,
}: {
  onClick: () => void;
  disabled?: boolean;
  modalHeader?: string;
  modalBody?: string;
}) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return modalHeader ? (
    <>
      <button
        className="bg-none cursor-pointer p-2 border-0 hover:opacity-100"
        onClick={onOpen}
        disabled={disabled}
      >
        <IconBuilder icon="Delete" />
      </button>
      <Modal
        disableAnimation={false}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="top"
        aria-label="Confirm delete"
      >
        {ModalBuilder({
          warning: true,
          modalHeader,
          modalBody,
          modalFooter: (
            <>
              <Button
                size="sm"
                radius="none"
                color="default"
                variant="bordered"
                onPress={onOpenChange}
              >
                Cancel
              </Button>
              <RedButton size="sm" onPress={onClick}>
                Delete
              </RedButton>
            </>
          ),
        })}
      </Modal>
    </>
  ) : (
    <button
      className="bg-none cursor-pointer p-2 border-0 hover:opacity-100"
      onClick={onClick}
      disabled={disabled}
    >
      <IconBuilder icon="Delete" />
    </button>
  );
};

export default DeleteButton;
